/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LanguagesTranslationsControllerRemoveTranslationsForLanguage$Params {

/**
 * The language code
 */
  languageCode: string;
}

export function languagesTranslationsControllerRemoveTranslationsForLanguage(http: HttpClient, rootUrl: string, params: LanguagesTranslationsControllerRemoveTranslationsForLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, languagesTranslationsControllerRemoveTranslationsForLanguage.PATH, 'post');
  if (params) {
    rb.path('languageCode', params.languageCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

languagesTranslationsControllerRemoveTranslationsForLanguage.PATH = '/languages-translations/language/{languageCode}/remove-translations';
